"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("@iov/crypto");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function hashTx(tx) {
    const hash = new crypto_1.Sha256(tx).digest();
    return hash;
}
exports.hashTx = hashTx;
//# sourceMappingURL=hasher.js.map